import api from '@motionelements/core/src/api/base-api-v2';

// eslint-disable-next-line
export const listFolderItems = (folderId, params, axiosConfig) => {
  return api.get(`/v2/folders/${folderId}/items`, {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
    ...(axiosConfig || {}),
  });
};
